import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { General_Config } from '../General_Config';

@Component({
  selector: 'app-preview',
  templateUrl: './preview.page.html',
  styleUrls: ['./preview.page.scss'],
})
export class PreviewPage implements OnInit {
  @Input() path: string;
  selected_language: string = window.localStorage.getItem(General_Config.session_key + 'selected_language');
  language: any = {};
  constructor(public modalController: ModalController) {
    fetch('./assets/languages/' + this.selected_language + '.json').then(res => res.json())
      .then(jsonData => {
        this.language = jsonData;
      });
  }

  ngOnInit() {
  }

  closeDialog() {
    this.modalController.dismiss({
      'dismissed': true
    });
  }

}
